export default __webpack_public_path__ + "static/media/user-img.3f710d50.png";